import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { FormField } from '../form-field/form-field';

export type InputProps = {
  invalid?: boolean;
  size?: 'small' | 'medium' | 'large';
  label?: React.ReactNode;
  error?: React.ReactNode;
  help?: React.ReactNode;
  icon?: (props: React.SVGProps<SVGSVGElement>) => React.ReactElement;
  iconPlacement?: 'left' | 'right';
  // this shadows the input size attribute defined in React.InputHTMLAttributes
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'>;

export const Input = forwardRef(
  (
    {
      invalid,
      size = 'medium',
      icon,
      iconPlacement = 'left',
      label,
      error,
      help,
      className,
      ...inputProps
    }: InputProps,
    ref: React.Ref<HTMLInputElement>
  ) => {
    const classNames = classnames(className, 'airtame-input', `airtame-input--${size}`, {
      [`airtame-input--with-icon-${iconPlacement}`]: icon,
    });

    return (
      <FormField
        label={label}
        invalid={invalid}
        labelPlacement="top"
        error={error}
        help={help}
        disabled={inputProps.disabled}
        className={classNames}
      >
        <input className={`airtame-input__input`} ref={ref} {...inputProps} />
        {icon && icon({ className: 'airtame-input__icon' })}
      </FormField>
    );
  }
);

Input.displayName = 'Input';
